import { useCallback, useEffect, useState } from "react";
import { getStoredSelectedAccountId } from "../Constants/accountTypes";
import {
  fetchContaInternacionalHistory,
  fetchContaInternacionalMovements,
} from "../Services/ibContaInternacionalHistoryApi";

/**
 * Live Conta internacional history from IB account statements.
 */
export const useContaInternacionalHistory = ({ accountKey } = {}) => {
  const resolvedAccountKey =
    accountKey !== undefined ? accountKey : getStoredSelectedAccountId();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await fetchContaInternacionalHistory();
      setItems(next);
    } catch (err) {
      setItems([]);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload, resolvedAccountKey]);

  return { items, loading, error, reload };
};

/**
 * Live Conta internacional movements (optionally filtered by currency id).
 */
export const useContaInternacionalMovements = ({ accountKey, currencyId } = {}) => {
  const resolvedAccountKey =
    accountKey !== undefined ? accountKey : getStoredSelectedAccountId();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await fetchContaInternacionalMovements({ currencyId });
      setItems(next);
    } catch (err) {
      setItems([]);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [currencyId]);

  useEffect(() => {
    reload();
  }, [reload, resolvedAccountKey]);

  return { items, loading, error, reload };
};
